import { rentalApplicationSchema } from '@/schemas/rentalApplication';
import { z } from 'zod';

export type RentalApplicationFormValues = z.infer<typeof rentalApplicationSchema>;
export enum IncomeType {
  WORK = 'Work',
  SELF_EMPLOYED = 'SelfEmployed',
  UNEMPLOYED = 'UnemploymentBenefit',
  STUDIES = 'Studies',
  PENSION = 'Pension',
  OWN_COMPANY = 'OwnCompany',
  ALLOWANCE = 'Allowance',
  OTHER = 'Other',
}
